import { ReloadButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import type { SearchFilterStatusWrapperProps as Props } from './types';

export const SearchFilterStatusWrapper = memo(
  ({ className, isLoading, isError, children, refetch }: Props) => {
    return (
      <Box
        className={classnames('SearchFilterStatusWrapper', className)}
        display={'flex'}
        flexDirection={'column'}
        gap={1}
      >
        {children}
        {isError && refetch && (
          <ReloadButton loading={isLoading} onReload={refetch} />
        )}
      </Box>
    );
  }
);

SearchFilterStatusWrapper.displayName = 'SearchFilterStatusWrapper';
